/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
// @material-ui/core components
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormGroup,
  FormLabel,
  LinearProgress,
  Select,
  MenuItem,
  FormControl,
  TextField,
  Typography,
} from "@material-ui/core";

// @material-ui/icons components
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// Karsten
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import useLogs from "hooks/logs";

export default function DialogRegistroProblema({
  open,
  handleClose,
  idPedido,
  dataOrder,
  setPedidoSelecionado,
  setRefreshPage,
}) {
  const [registrando, setRegistrando] = React.useState(false);
  const [observacao, setObservacao] = React.useState("");
  const [motivo, setMotivo] = React.useState("");
  const [listaMotivos, setListaMotivos] = React.useState([]);
  const [carregandoMotivos, setCarregandoMotivos] = React.useState(true);
  const snackbar = useSnackbar();
  const { setLocalStorageApiProblem } = useLogs();

  const getMotivoById = React.useCallback(
    (id) => {
      return listaMotivos.find((motivo) => motivo.IdMotivo === id);
    },
    [listaMotivos]
  );

  const fetchReasons = React.useCallback(async () => {
    return await Api.get("list-reasons-problems", "order", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setListaMotivos(Result);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "12",
          screen: "Consulta Retire na Loja",
          problem: `Erro na chamada do endpoint list-reasons-problems - ${error}`,
        });
      })
      .finally(() => setCarregandoMotivos(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = React.useCallback(async () => {
    setRegistrando(true);

    await Api.postParams(
      "set-problem-collect-in-store-order",
      "order",
      "?idPedido=" +
        idPedido +
        "&idMotivo=" +
        motivo +
        "&observacao=" +
        observacao,
      true
    )
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage(
            `Registro de problema com o Pedido ${idPedido} realizado com sucesso!`,
            {
              severity: "success",
            }
          );

          dataOrder.Status = "Com Problema";
          dataOrder.StatusProblema = "Com Problema";
          dataOrder.MotivoProblema = getMotivoById(
            res.Result.IdMotivoProblema
          ).Motivo;

          setPedidoSelecionado(null);
          setRefreshPage(true);

          handleClose();
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(
          "Ocorreu um erro ao registrar problema. Verifique os parâmetros informados.",
          {
            severity: "error",
          }
        );
        setLocalStorageApiProblem({
          idMenuAccess: "12",
          screen: "Consulta Retire na Loja",
          problem: `Erro na chamada do endpoint set-problem-collect-in-store-order - ${error}`,
        });
      })
      .finally(() => setRegistrando(false));
  }, [
    idPedido,
    motivo,
    observacao,
    snackbar,
    dataOrder,
    getMotivoById,
    handleClose,
  ]);

  React.useEffect(() => {
    fetchReasons();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <span>
          <Typography variant="h3" component="h3">
            Registrar problema com o pedido {idPedido}
          </Typography>
        </span>
      </DialogTitle>
      <DialogContent
        style={{ overflowY: "hidden", padding: "0 1.5rem 1.5rem" }}
      >
        <Typography id="alert-dialog-description" variant="h4">
          Preencha o motivo do problema e acrescente observações se necessário.
        </Typography>
        <br />
        {!carregandoMotivos && (
          <FormGroup>
            <FormControl variant="outlined" required fullWidth>
              <FormLabel>Motivo</FormLabel>
              <Select
                fullWidth
                variant="outlined"
                label="Motivo"
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                IconComponent={KeyboardArrowDownIcon}
              >
                {listaMotivos.map((motivo, index) => (
                  <MenuItem key={index} value={motivo.IdMotivo}>
                    {motivo.Motivo}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </FormGroup>
        )}
        <FormGroup>
          <FormLabel>Observações</FormLabel>
          <TextField
            placeholder="Observação"
            multiline
            value={observacao}
            onChange={(event) => setObservacao(event.target.value)}
            variant="outlined"
            disabled={registrando}
            onInput={(e) =>
              (e.target.value = e.target.value.toString().slice(0, 4000))
            }
          />
        </FormGroup>
        {registrando && (
          <div>
            <span>Registrando problema...</span>
            <LinearProgress />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button component={Box} onClick={handleClose} disabled={registrando}>
          Cancelar
        </Button>
        <Button
          component={Box}
          variant="contained"
          onClick={submit}
          disabled={registrando}
        >
          Registrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
